<template>
    <div class="test-results">
        <h2 class="text-center mb-5">Skills: The Finals</h2>
        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het realistische type</h2>
                <h3 class="text-right sub-title">“De doener”</h3>
            </div>
            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/realistic.png"
                        alt="Het realistische type; de doener" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['realistic'] }} {{ resultData['realistic'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Actie!</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Aanpassingsvermogen, Direct, Eerlijk, Evenwichtig, Bescheiden, Vasthoudend, Harde werker,
                        Praktisch, Handig, Doelgericht
                    </p>
                    <h4>Wie is de doener?</h4>
                    <p>
                        Mijn motto? Geen woorden maar daden. Ik ben nogal praktisch ingesteld; dat wil zeggen dat ik het
                        liefst gewoon bezig ben. Ik wil de handen uit de mouwen steken. Je kunt het zo gek niet
                        bedenken, als er maar actie in zit. Ik kan me dan echt uitleven.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>Techniek & gebouwde omgeving</li>
                        <li>Mobiliteit & transport</li>
                        <li>Voedsel, groen & gastvrijheid</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het explorerende type</h2>
                <h3 class="text-right sub-title">“De onderzoeker”</h3>
            </div>

            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/investigative.png"
                        alt="Het explorerende type; de onderzoeker" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['investigative'] }}
                        {{ resultData['investigative'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Analyseren en oplossen</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Aanpassen, Direct, Eerlijk, Evenwichtig, Bescheiden, Vast houdend, Harde werker, Praktisch,
                        Handig, Doelgericht
                    </p>
                    <h4>Wie is de onderzoeker?</h4>
                    <p>
                        Ik wil altijd weten hoe iets in elkaar zit en waarom bepaalde dingen zijn zoals ze zijn.
                        Eigenlijk ben ik altijd op zoek naar redenen, oorzaken en achtergronden. Door te onderzoeken
                        snap ik waarom dingen zijn zoals ze zijn, begrijp ik hoe dingen werken en dat geeft een kick.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>Techniek & gebouwde omgeving</li>
                        <li>Zakelijke dienstverlening & veiligheid</li>
                        <li>Zorg, welzijn & sport</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het artistieke type</h2>
                <h3 class="text-right sub-title">“De creatieveling”</h3>
            </div>
            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/artistic.png"
                        alt="Het artistieke type; de creatieveling" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['artistic'] }} {{ resultData['artistic'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Create & Expressie</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Creatief, Open, Zelfstandig, Origineel, Fantasierijk, Enthousiast, Impulsief, Eigenzinnig,
                        Flexibel, Gevoelig
                    </p>
                    <h4>Wie is de creatieveling?</h4>
                    <p>
                        Ik heb veel fantasie. Als er iets gemaakt of gedaan moet worden dan bruis ik van de ideeën. Ik
                        leef me graag uit in tekenen, handvaardigheid, maar ook in muziek en dans. Ik vind het gaaf om
                        te zien hoe iets moois gemaakt kan worden en ontdek graag welke ideeën er achter zitten.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>ICT & creatieve industrie</li>
                        <li>Handel</li>
                        <li>Techniek & gebouwde omgeving</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het sociale type</h2>
                <h3 class="text-right sub-title">“De helper”</h3>
            </div>
            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/social.png"
                        alt="Het sociale type; de helper" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['social'] }} {{ resultData['social'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Zorgen voor anderen</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Samenwerker, Vriendelijk, Inlevingsvermogen, Behulpzaam, Geduldig, Makkelijk contact maken,
                        Warm, Zorgzaam, Luisteren, Belangstellend
                    </p>
                    <h4>Wie is de helper?</h4>
                    <p>
                        Ik ben het liefst onder de mensen. Of ik nu thuis ben of op school, ik heb altijd een groepje om
                        me heen. Gezellig kletsen, maar toch ook over serieuze zaken praten. Ik leer graag nieuwe mensen
                        kennen en dat gaat me gemakkelijk af.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>Voedsel, groen & gastvrijheid</li>
                        <li>Zakelijke dienstverlening & veiligheid</li>
                        <li>Zorg, welzijn & sport</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het conventionele type</h2>
                <h3 class="text-right sub-title">“De organisator”</h3>
            </div>
            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/conventional.png"
                        alt="Het conventionele type; de organisator" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['conventional'] }}
                        {{ resultData['conventional'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Leiderschap & uitdaging</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Avontuurlijk, Makkelijke prater, Op de voorgrond, Zelfverzekerd, Positief, Energiek,
                        Besluitvaardig, Daadkrachtig, Actief, Doelgericht
                    </p>
                    <h4>Wie is de organisator?</h4>
                    <p>
                        Ze noemen mij wel eens "haantje de voorste" en dat komt omdat ik niet op mijn mondje gevallen
                        ben. Ik houd ervan om initiatief te nemen. Regelen en iets organiseren; laat dat maar aan mij
                        over. Ik vind het leuk om iets aan te pakken en ervoor te zorgen dat alles goed verloopt.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>Mobiliteit & transport</li>
                        <li>Handel</li>
                        <li>Voedsel, groen & gastvrijheid</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div class="title-header">
                <h2 class="text-right main-title">Het ondernemende type</h2>
                <h3 class="text-right sub-title">“De overtuiger”</h3>
            </div>
            <div class="row">
                <div class="col-md-4 d-flex flex-column">
                    <img
                        class="img-fluid"
                        src="/images/tests/lobx-job-event-test-2024-12-19/enterprising.png"
                        alt="Het ondernemende type; de overtuiger" />
                    <h2 class="my-4 mx-auto">
                        {{ resultData['enterprising'] }}
                        {{ resultData['enterprising'].length === 1 ? 'punt' : 'punten' }}
                    </h2>
                </div>
                <div class="col-md-8">
                    <h4>Waar word ik blij van?</h4>
                    <p>Orde en regelmaat</p>
                    <h4>Mijn eigenschappen:</h4>
                    <p>
                        Nauwkeurig, Structuur, Serieus, Behulpzaam, Geduldig, Evenwichtig, Bedachtzaam, Doelgericht,
                        Praktisch, Zelfstandig
                    </p>
                    <h4>Wie is de overtuiger?</h4>
                    <p>
                        Voor mij is het belangrijk om te weten waar ik aan toe ben. Ik houd niet van onverwachte
                        situaties en ben het liefst steeds goed voorbereid. Ik houd van structuur en overzicht. Mijn
                        kamer ziet er daarom meestal netjes uit en ik weet alles behoorlijk snel te vinden. Als ik iets
                        bewaar of opberg dan zit daar een systeem in.
                    </p>
                    <h4>Werelden die bij mij passen:</h4>
                    <ul>
                        <li>Mobiliteit & transport</li>
                        <li>Zakelijke dienstverlening & veiligheid</li>
                        <li>ICT & creatieve industrie</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        resultData: {
            type: Object,
        },
    },
};
</script>

<style scoped lang="scss">
.title-header {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    row-gap: map-get($grid-gutter-spacing, 'six');
    margin-bottom: $grid-gutter-width;
}

.main-title,
.sub-title {
    text-transform: uppercase;
    background-color: $black;
    color: $white;
    padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');
    width: auto;
    margin-left: auto;
}

.main-title {
    transform: rotate(-3deg);
}

.sub-title {
    transform: rotate(2deg);
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
}

.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
